import { Watch, Component, Prop } from 'vue-property-decorator';
import UrlMixin from '@/components/query/url-mixin';
import { mixins } from 'vue-class-component';


@Component
export default class Selection extends mixins<UrlMixin>(UrlMixin) {
  @Prop({ default: {} })
  parentRow: { DT_RowId:string };
  
  checkboxState = this.mappedSelectedItems

  get selectedItems() {
    return this.$store.state.table.selectedItems || []
  }

  isRowSelected(row) {
    return this.selectedItems.find((item) => item.DT_RowId === row.DT_RowId  && this.parentRow.DT_RowId === item.parentID)
  }
  
  @Watch('$route')
  resetSelectedItems() {
    this.checkboxState = this.mappedSelectedItems
  }

  @Watch('$store.state.table.selectedItems')
  onChangeSelectedItems(value) {
    if (value.length !== Object.keys(this.checkboxState).length) {
      this.resetSelectedItems()
    }
  }

  get mappedSelectedItems() {
    return this.$store.state.table.selectedItems.reduce((acc, item) => {
      acc[item.DT_RowId] = item
      return acc
    }, {})
  }

  @Watch('checkboxState', { deep: true })
  check(val) {
    const selectedRows = Object.values(val).filter(value => !!value)
    this.onRowSelect(selectedRows, 0)
  }

  onRowClick(data: any) {
    if (!(this as any).isAllowSelectRow) return;
    if( this.isRowSelected(data)){
      this.checkboxState = {}
    }else{
      this.checkboxState =  {
        [data.DT_RowId]: {
          ...data,
          parentID:this.parentRow?.DT_RowId
        }
      }
    }
  }

  onRowSelect(data, treeLevel) {
    this.$store.commit('tableSelectedItems', data);

    const value = data.length == 1 ? data[0] : null;

    if (value && value.DT_RowUrl) {
      this.$store.commit('tablePreviewLink', value.DT_RowUrl);
    } else {
      this.$store.commit('tablePreviewLink', null);
    }

    if (value && value.DT_RowId) {
      this.$store.commit('tableNextReportTreeLevel', treeLevel);
      this.$store.commit('tableNextReportGroup', this.getGroupByMetric(value.grouping) || this.$route.params.type); // TODO: check route
    } else {
      this.$store.commit('tableNextReportTreeLevel', 0);
      this.$store.commit('tableNextReportGroup', null);
    }
  }
}
